<template>
  <div id="itemChooser">
    <input
      type="text"
      :placeholder="placeholder"
      class="form-control"
      @click="showModal = true"
    />
    <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div id="modal" class="modal-container">
            <div class="modal-body">
            
              <div class="row" v-if="sourcetype === 'EXTERNAL' || sourcetype === null">
                <div class="col-md-4">
                  <label>Bab:</label>
                  <select
                    name=""
                    id=""
                    class="form-control"
                    v-model="chapterIndex"
                  >
                    <option value="" disabled>-- PILIH BAB --</option>
                    <option
                      :value="index"
                      v-bind:key="index"
                      v-for="(chapter, index) in topics"
                    >
                      {{ chapter.nama }}
                    </option>
                  </select>
                </div>
                <div
                  class="col-md-4"
                  v-if="
                    chapterIndex !== '' && topics[chapterIndex].subs.length > 0
                  "
                >
                  <label>Sub Bab (Optional):</label>
                  <select
                    name=""
                    id=""
                    class="form-control"
                    v-model="subChapterIndex"
                  >
                    <option value="">-- PILIH SUB BAB --</option>
                    <option
                      :value="index"
                      v-bind:key="index"
                      v-for="(sub, index) in topics[chapterIndex].subs"
                    >
                      {{ sub.nama }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4" v-if="chapterIndex !== ''">
                  <label>Gunakan tipe semua</label>
                  <br />
                  <input type="checkbox" v-model="allFilterToggle" /> Tipe semua
                  (4)
                </div>
              </div>
              <div class="row m-t-10">
                <div class="col-md-12">
                  <button
                    type="button"
                    class="btn btn-success btn-block"
                    @click="search()"
                  >
                    Cari
                  </button>
                </div>
              </div>
              <div class="row m-t-10" v-if="items.length > 0">
                <app-datatable
                  :items="items"
                  :headers="headers"
                  v-on:selected="selectedItem = $event"
                  v-on:dblClicked="confirmSelectedItem()"
                ></app-datatable>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-danger"
                @click="showModal = false"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import ItembankService from "@/services/itembank.js";
import DataTable from "@/components/plugins/DataTable";

export default {
  name: "app-itemchooser",
  props: {
    subject: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    topiclist: {
      required: false,
      default: null,
    },
    sourcetype: {
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
      default: "Cari Soal...",
    },
  },
  components: {
    "app-datatable": DataTable,
  },
  data: function () {
    return {
      headers: ["Kode Soal", "Bab", "Sub Bab", "Sub Sub Bab", "eigen", "label"],
      showModal: false,
      chapterIndex: "",
      subChapterIndex: "",
      topics: [],
      items: [],
      selectedItem: null,
      allFilterToggle: false,
    };
  },
  watch: {
    subject: function (val) {
      this.topics = [];
      this.loadTopicData();
    },
    showModal: function (to, from) {
      // console.log(this.sourcetype);
      if (to) {
        if (this.sourcetype === "INTERNAL") this.search();
      } else {
        this.chapterIndex = "";
        this.subChapterIndex = "";
        this.items = [];
        this.headers = [
          "Kode Soal",
          "Bab",
          "Sub Bab",
          "Sub Sub Bab",
          "eigen",
          "label",
        ];
      }
    },
  },
  methods: {
    loadTopicData: function () {
      var context = this;
      if (context.topiclist == null) {
        ItembankService.getListOfTopic(this.subject.code, function (result) {
          if (result.success) {
            result.data.forEach(function (topic) {
              context.topics.push(topic);
            });
            context.$store.commit("tryoutRevisiMapelList", [
              context.subject_code,
              context.topics,
            ]);
          }
        });
      } else {
        context.topics = context.topiclist;
      }
    },
    search: function () {
      var context = this;
      if (this.sourcetype === "INTERNAL") {
        let params = {
          level: context.$store.state.tryout.level,
          mapel_code: context.subject.code,
          item_type: context.$store.state.tryout.type,
        };
        ItembankService.searchRandomItemByItemNameV2(params, function (result) {
          context.headers.push("Tipe");
          if (result.success) {
            result.data.forEach(function (item) {
              var subChapter = "-";
              var subSubChapter = "-";

              if (item.subbab_name != null) subChapter = item.subbab_name;
              if (item.subsubbab_name != null)
                subSubChapter = item.subsubbab_name;

              var row = {
                id: item.id,
                data: [
                  item.code,
                  item.bab_name,
                  subChapter,
                  subSubChapter,
                  item.eigen,
                  "-",
                  item.question_type,
                ],
              };
              context.items.push(row);
            });
          }
        });
      } else {
        this.items.splice(0, this.items.length);
        var itemCode = this.getItemCode();
        ItembankService.searchItemByItemCode(itemCode, function (result) {
          if (result.success) {
            result.data.forEach(function (item) {
              var subChapter = "-";
              var subSubChapter = "-";
              if (item.sub_bab != null) subChapter = item.sub_bab.nama;
              if (item.sub_sub_bab != null)
                subSubChapter = item.sub_sub_bab.nama;

              var row = {
                id: item.id,
                data: [
                  item.kode,
                  item.bab.nama,
                  subChapter,
                  subSubChapter,
                  item.nilai_eigen,
                  item.label,
                ],
              };
              context.items.push(row);
            });
          }
        });
      }
    },
    getItemCode: function () {
      var chapter = null;
      var subChapter = null;

      var itemCode = "";
      switch (this.$store.state.tryout.level) {
        case "SMA":
          itemCode += "3";
          break;
        case "SMP":
          itemCode += "2";
          break;
        case "SD":
          itemCode += "1";
          break;
        default:
          itemCode += "3";
      }

      if (this.allFilterToggle) {
        itemCode += "4";
      } else {
        switch (this.$store.state.tryout.type) {
          case "SBMPTN":
            itemCode += "1";
            break;
          case "UJIAN_MANDIRI":
            itemCode += "1";
            break;
          case "UJIAN_AKHIR_NASIONAL":
            itemCode += "2";
            break;
          case "UJIAN_AKHIR_SEKOLAH":
            itemCode += "3";
            break;
          default:
            itemCode += "4";
        }
      }

      itemCode += this.subject.code;
      chapter = this.topics[this.chapterIndex];
      itemCode += chapter.kode;

      subChapter = null;
      if (this.subChapterIndex != "") {
        subChapter = chapter.subs[this.subChapterIndex];
        itemCode += subChapter.kode;
      }

      return itemCode;
    },
    confirmSelectedItem: function () {
      this.showModal = false;
      this.$emit("selected", this.selectedItem);
    },
  },
  mounted: function () {
    // console.log(this.topiclist)
    this.loadTopicData();
  },
};
</script>



// WEBPACK FOOTER //
// ItemChooser.vue?6b892ee4